var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 88,
  height: 88,
  viewBox: "0 0 88 88"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_317",
  "data-name": "Ellipse 317",
  cx: 44,
  cy: 44,
  r: 44,
  fill: "#ffeaa5"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "PersonIcon",
  d: "M32,31.45A10.79,10.79,0,0,1,20.75,20.2,10.79,10.79,0,0,1,32,8.95,10.79,10.79,0,0,1,43.25,20.2,10.79,10.79,0,0,1,32,31.45ZM8,55.525v-7.05A8.254,8.254,0,0,1,9.425,43.6,9.149,9.149,0,0,1,13.1,40.525a56.374,56.374,0,0,1,9.638-3.375A38.959,38.959,0,0,1,32,36.025a37.32,37.32,0,0,1,9.225,1.163,63.889,63.889,0,0,1,9.6,3.337,9.043,9.043,0,0,1,3.75,3.075A8.254,8.254,0,0,1,56,48.475v7.05Zm4.5-4.5h39v-2.55a4.109,4.109,0,0,0-.712-2.287,4.516,4.516,0,0,0-1.763-1.613,39.826,39.826,0,0,0-8.775-3.187A38.8,38.8,0,0,0,32,40.525a39.859,39.859,0,0,0-8.325.863A38.093,38.093,0,0,0,14.9,44.575a4.513,4.513,0,0,0-2.4,3.9ZM32,26.95a6.541,6.541,0,0,0,6.75-6.75A6.541,6.541,0,0,0,32,13.45a6.541,6.541,0,0,0-6.75,6.75A6.541,6.541,0,0,0,32,26.95Zm0-6.75Zm0,30.825Z",
  transform: "translate(11.799 10.05)",
  fill: "#f5b709"
})));
export default __webpack_public_path__ + "static/media/individualican.f6e859d5.svg";
export { SvgComponent as ReactComponent };